import { useMemo } from 'react';
import { Meta } from '~/lib/api/smartsend/types';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { BuyerNote, DeliveryInstructions, DeliverySafePlace, LabelReference } from '../../lib/consts/ItemMetaConstants';
import { EditMetaModel, ItemMeta } from './ItemMeta';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  onUpdate?: (meta: EditMetaModel) => void;
  meta: Meta;
}

export const CustomerMeta: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const includedMetaFields = useMemo(() => {
    const itemMetaDefaultFields: string[] = [];
    if (SettingsCache.settings.Features.includes(`DeliveryInstructions`)) {
      itemMetaDefaultFields.push(DeliveryInstructions);
    }
    if (SettingsCache.settings.Features.includes(`DeliverySafePlace`)) {
      itemMetaDefaultFields.push(DeliverySafePlace);
    }
    if (SettingsCache.settings.Features.includes(`DeliveryBuyerNote`)) {
      itemMetaDefaultFields.push(BuyerNote);
    }
    return itemMetaDefaultFields;
  }, []);

  if (includedMetaFields.length == 0) {
    return null;
  }

  return (
    <ItemMeta
      meta={props.meta}
      onUpdate={props.onUpdate}
      title={t('DELIVERY_INSTRUCTIONS_SUBTITLE', { defaultValue: 'Delivery Instructions' })}
      includeOrCreate={includedMetaFields}
      readOnly={[LabelReference]}
    />
  );
};
